import { execFile } from 'node:child_process';
import { promisify } from 'node:util';
import type { GitStatus } from './context-types.js';

const execFileAsync = promisify(execFile);

export async function readGitStatus(workspaceRoot: string): Promise<GitStatus> {
  try {
    const [statusResult, branchResult] = await Promise.all([
      execFileAsync('git', ['status', '--porcelain'], { cwd: workspaceRoot }),
      execFileAsync('git', ['branch', '--show-current'], { cwd: workspaceRoot }),
    ]);
    const entries = statusResult.stdout
      .split(/\r?\n/)
      .map((line) => line.trimEnd())
      .filter(Boolean)
      .map((line) => ({ status: line.slice(0, 2).trim(), path: line.slice(3).trim() }));
    return {
      branch: branchResult.stdout.trim() || null,
      entries,
      available: true,
    };
  } catch (error) {
    return {
      branch: null,
      entries: [],
      available: false,
      error: error instanceof Error ? error.message : String(error),
    };
  }
}
